import React from "react";
import "./Logojd.css";

const CodeEditor = () => {
  return (
    <div className="logo-container">
      <div className="logo-wrap">
        <div className="logo-svg-wrap">
          <img className="fire-jd" src="firejd.svg" alt="justjd" />
        </div>
        <div className="just-dev">
          <span>Key</span>
          <span className="just-dev-dev">Deb</span>
        </div>
      </div>
    </div>
  );
};

export default CodeEditor;
